import ProgramsHero from "./components/ProgramsHero";
import WingsSection from "./components/WingsSection";
import ImpactSection from "./components/ImpactSection";

export default function Programs() {
  return (
    <main className="min-h-screen">
      <ProgramsHero />
      <WingsSection />
      <ImpactSection />
    </main>
  );
}